import React, { type ComponentType } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import PageHeader from '@atlassian/jira-common-components-page-header/src/index.tsx';
import { DocumentTitle } from '@atlassian/jira-global-document-title/src/DocumentTitle.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import type { DirectoryProps } from '../model/index.tsx';
import messages from './messages.tsx';

type Props = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	CreateButton: ComponentType<Record<any, any>>;
	BoardsDirectory: ComponentType<DirectoryProps>;
} & DirectoryProps & {
		intl: IntlShape;
	};

const BoardsPage = (props: Props): React.JSX.Element => {
	const {
		CreateButton,
		BoardsDirectory,
		intl: { formatMessage },
		...boardsDirectoryProps
	} = props;

	const actions = <CreateButton />;
	return (
		<>
			<DocumentTitle title={formatMessage(messages.pageTitle)} />
			<Box xcss={isVisualRefreshEnabled() ? pageHeaderStyles : undefined}>
				<PageHeader truncateTitle actions={actions}>
					{formatMessage(messages.pageTitle)}
				</PageHeader>
			</Box>
			<BoardsDirectory {...boardsDirectoryProps} />
		</>
	);
};

const pageHeaderStyles = xcss({
	marginBottom: 'space.negative.050',
});

export default BoardsPage;
